var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-session-2"},[_c('Echart',{attrs:{"options":_vm.options,"id":"bottomLeftChart1","height":"220px","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }